

export const capitalizeFirst = (str: string) => {
  if(str===undefined)
    return '';
  else
    return str.charAt(0).toUpperCase() + str.slice(1);
  };